import { render, staticRenderFns } from "./mine-header.vue?vue&type=template&id=24ea5053&scoped=true"
import script from "./mine-header.vue?vue&type=script&lang=js"
export * from "./mine-header.vue?vue&type=script&lang=js"
import style0 from "./mine-header.vue?vue&type=style&index=0&id=24ea5053&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea5053",
  null
  
)

export default component.exports